import { Accordion, Flex, Separator, theme, Typography } from '@fe-toolkit/web-components/ssr'

import { Plan } from '@/api'
import { formatDate, shortMonthInformal } from '@/utils/formatDate/formatDate'
import { formatPriceFromPenceToPounds } from '@/utils/formatPrice'

import { ChangePlanUIInfo } from '../utils/formatPlanPaymentAttributes'

export type ChangePlanPaymentDetailsProps = {
  planInfo: ChangePlanUIInfo
  plan?: Plan
}

export default function ChangePlanPaymentDetails({ planInfo, plan }: Readonly<ChangePlanPaymentDetailsProps>) {
  const isPromoPlan = !!plan?.promotionalProduct

  return (
    <Flex data-testid="confirm-plan-change-payment-details" flexDirection="column" gap={theme.spacing.small}>
      <Typography as="h3" variant="loudBold">
        Payment details
      </Typography>
      <Accordion label="Total today" open={true} rightText={planInfo.totalToday}>
        {planInfo.changeType === 'upgrade' && (
          <>
            <Typography as="p" data={planInfo} variant="whisper">
              Great news, you can enjoy your upgraded plan speed on us for the rest of this month.
            </Typography>

            <Typography as="p" variant="speak">
              {planInfo.totalToday}
            </Typography>

            <Separator my="small" />
          </>
        )}

        {isPromoPlan ? (
          <>
            <Typography as="p" variant="whisper">
              Next {plan.promotionPeriodInMonths} monthly payments starting {planInfo.startDate}
            </Typography>
            <Typography as="p" variant="speak">
              {formatPriceFromPenceToPounds(Number(plan.monthlyPrice) * 100)}
            </Typography>
            <Separator my="small" />
            <Typography as="p" variant="whisper">
              Ongoing monthly payment starting {formatDate(plan.promotionEndDate, { options: shortMonthInformal })}
            </Typography>
            <Typography as="p" variant="speak">
              {formatPriceFromPenceToPounds(Number(plan.postPromotionMonthlyPrice) * 100)}
            </Typography>
          </>
        ) : (
          <>
            <Typography as="p" data={planInfo} variant="whisper">
              Ongoing monthly payment starting {planInfo.startDate}
            </Typography>
            <Typography as="p" variant="speak">
              {planInfo.totalMonthly}
            </Typography>
          </>
        )}
      </Accordion>
    </Flex>
  )
}
